import { useEffect } from 'react';

import FoodSections from '../../../molecules/Desktop/FoodEntrepreneurs/FoodSections';

const FoodEntrepreneurs = () => {
  useEffect(() => {
    document.title = `HomeCook | Food Entrepreneurs`;
  }, []);

  return (
    <>
      <FoodSections />
    </>
  );
};

export default FoodEntrepreneurs;